

const cartFile = process.env.NODE_ENV === 'development' ? `/data/cartMock.json` : `/src/data/cartMock.json`;
const enabledShippingModesFile = process.env.NODE_ENV === 'development' ? `/data/enabledShippingModesMock.json` : `/src/data/enabledShippingModesMock.json`;
const promoCodeFile = process.env.NODE_ENV === 'development' ? `/data/promoCodeMock.json` : `/src/data/promoCodeMock.json`;
const addressFile = process.env.NODE_ENV === 'development' ? `/data/addressFile.json` : `/src/data/addressFile.json`;
const frameFile = process.env.NODE_ENV === 'development' ? `/data/18799656.json` : `/src/data/18799656.json`;
const lensesFile = process.env.NODE_ENV === 'development' ? `/data/18852442.json` : `/src/data/18852442.json`;
const faqFile = process.env.NODE_ENV === 'development' ? `/data/faqFile.json` : `/src/data/faqFile.json`;
const footerFile = process.env.NODE_ENV === 'development' ? `/data/footerFile.json` : `/src/data/footerFile.json`;
const personFile = process.env.NODE_ENV === 'development' ? `data/personFile.json` : `/src/data/personFile.json`;
const physicalStoreFile = process.env.NODE_ENV === 'development' ? `/data/bossPhysicalStores.json` : `/src/data/bossPhysicalStores.json`;
const bossSelectedStore = process.env.NODE_ENV === 'development' ? `/data/getMockBossStoreSelected.json` : `/src/data/getMockBossStoreSelected.json`;
const orderFile = process.env.NODE_ENV === 'development' ? `/data/orderMock.json` : `/src/data/orderMock.json`;

const readFile = async (file: string) : Promise<any> => {
    const data = await fetch(file);
    const dataJson = await data.json();
    
    return new Promise((resolve, reject) => {
      if(dataJson) resolve({data: dataJson});
      reject();
    });
}

/* MOCK CART */
export const getMockCart = async () => {
    return await readFile(cartFile);
}

/* MOCK PROMO CODE */
export const getMockPromoCode = async () => {
    return await readFile(promoCodeFile);
}

/* MOCK ENABLED SHIPPING MODES */
export const getMockEnabledShippingModes = async () => {
    return await readFile(enabledShippingModesFile);
}

/* MOCK ADDRESS */
export const getMockAddress = async () => {
    return await readFile(addressFile)
}

/* MOCK FRAME PROPERTIES */
export const getMockFrameProperties = async () => {
    return await readFile(frameFile).then(res => res.data);
}

/* MOCK LENSES PROPERTIES */
export const getMockLensesProperties = async () => {
    return await readFile(lensesFile).then(res => res.data);
}

/* MOCK FAQ */
export const getMockFaq = async () => {
    return await readFile(faqFile);
}

/* MOCK FOOTER */
export const getMockFooter = async () => {
    return await readFile(footerFile);
}

/* MOCK PERSON */
export const getMockPerson = async () => {
    return await readFile(personFile);
}


/* MOCK BOSS */
export const getMockedPhysicalStore = async () => {
    return await readFile(physicalStoreFile);
}

export const getMockBossStoreSelected = async () => {
    return await readFile(bossSelectedStore);
}

/* MOCK ORDER */
export const getMockOrder = async() => {
    return await readFile(orderFile);
}
